<template>
<div>
    <div class="addressform row ml-10">
        <div class="form-group col-md-12 row Authority">
            <label class="col-lg-4 col-md-3 control-label">House No</label>
            <div class="col-lg-8 col-md-9">
                <input type="text" class="form-control form-cascade-control input-small" v-model="houseno">
            </div>
        </div>
        <div class="form-group col-md-12 row Authority">
            <label class="col-lg-4 col-md-3 control-label">Street</label>
            <div class="col-lg-8 col-md-9">
                <textarea class="form-control form-cascade-control input-small" v-model="street" cols="20" rows="2" style="height:80px;"></textarea>
            </div>
        </div>
        <div class="form-group col-md-12 row Authority">
            <label class="col-lg-4 col-md-3 control-label">Landmark</label>
            <div class="col-lg-8 col-md-9">
                <input type="text" class="form-control form-cascade-control input-small" v-model="landmark">
            </div>
        </div>
        <div class="form-group col-md-12 row Authority">
            <label class="col-lg-4 col-md-3 control-label">City</label>
            <div class="col-lg-8 col-md-9">
                <div v-if="office == 1">
                    <input type="text" class="form-control form-cascade-control input-small" v-model="city">
                </div>
                <div v-else>
                    <select class="form-control form-cascade-control input-small" style="background-color: rgb(255, 255, 255);" v-model="city">
                        <option :value="0">-- Select --</option>
                        <option v-for="item in getmastertype(MASTER_CITIES)" :key="item.labelid" :value="item.labelid">{{ item.label }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="form-group col-md-12 row Authority">
            <label class="col-lg-4 col-md-3 control-label">Pincode</label>
            <div class="col-lg-8 col-md-9">
                <input type="text" class="form-control form-cascade-control input-small" v-model="zipcode" @input="zipcodeValidation()">
                <div class="text-end">{{ zipcodeLength }}/6</div>
            </div>
        </div>
        <div class="form-group col-md-12 Authority text-center">
            <button type="button" class="btn btn-success" @click="saveAddress()">
                {{ hasAddress ? 'Update Address' : 'Save Address' }}
            </button>
        </div>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Constants from '../utilities/Constants.vue'

export default {
    mixins: [Constants],
    props: {
        office: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            houseno: '',
            street: '',
            landmark: '',
            city: 0,
            zipcode: '',
            currentAddress: null
        }
    },
    computed: {
        ...mapGetters(['addressess', 'selectedaddress']),
        hasAddress() {
            return this.currentAddress != null || (this.addressess != null && this.addressess.length > 0)
        },
        zipcodeLength() {
            return this.zipcode == null ? 0 : this.zipcode.toString().length
        }
    },
    mounted() {
        this.loadAddress()
    },
    watch: {
        selectedaddress() {
            this.loadAddress()
        },
        addressess() {
            this.loadAddress()
        }
    },
    methods: {
        loadAddress() {
            let address = this.selectedaddress
            if (address == null && this.addressess != null && this.addressess.length > 0) {
                address = this.addressess[0]
            }
            this.currentAddress = address
            this.houseno = address?.houseno ?? ''
            this.street = address?.street ?? ''
            this.landmark = address?.landmark ?? ''
            this.city = address?.city ?? 0
            this.zipcode = address?.zipcode ?? ''
        },
        buildAddress() {
            return {
                id: this.currentAddress?.id ?? 0,
                localid: this.currentAddress?.localid ?? 0,
                addresstype: 0,
                houseno: this.houseno,
                street: this.street,
                landmark: this.landmark,
                city: this.city,
                zipcode: this.zipcode,
                country: this.currentAddress?.country ?? '',
                staytype: this.currentAddress?.staytype ?? 0
            }
        },
        saveAddress() {
            let hasContent = this.houseno != '' || this.street != '' || this.landmark != '' || this.city != 0 || this.zipcode != ''
            if (!hasContent) {
                alert('Please enter address details.')
                return
            }

            let isUpdate = this.currentAddress != null || (this.addressess != null && this.addressess.length > 0)
            let address = this.buildAddress()
            this.$store.commit('assignaddressess', [address])
            this.$store.commit('assignselectedaddress', address)
            this.currentAddress = address
            this.$notify({
                text: isUpdate ? 'Address updated successfully' : 'Address saved successfully',
                type: 'success',
                duration: '5000',
                speed: '300',
                closeOnClick: false
            })
        }
    }
}
</script>
